angular.module('app')
    .directive('animatedServiceFlows', animatedServiceFlows)
function animatedServiceFlows() {
    return {
        restrict: 'E',
        require: {
            scrollableContents: '^^scrollableContents',
            scrollableItem: '^^scrollableItem'
        },
        link: link
    }

    function link(scope, element, attrs, ctrl) {
        const container = angular.element(element);
        const isMobile = ctrl.scrollableContents.isMobile;
        
        let tweenServiceFlow = null;
        function animate() {
            const logoImg = container.find('.logo-img');
            const xLargeText = container.find('.xlarge-text');
            const introText = container.find('.intro-text');
            const serviceFlowsContainer = container.find('.service-flows');
            const serviceFlows = container.find('.service-flow');
            const serviceFlowBoxes = container.find('.service-flow-box');
            const serviceFlowLines = container.find('.service-flow-line');
            const serviceFlowCircles = container.find('.service-flow-circle');

            if (!isMobile) {
                tweenServiceFlow = new TimelineMax()
                    .set(serviceFlowsContainer, { opacity: 1 })
                    .set(logoImg, { opacity: 0 })
                    .to(logoImg, 1.5, { opacity: 0.7, startAt: { y: 400 }, y: 0, ease: Elastic.easeInOut })
                    .to(xLargeText, 0.5, { y: 0, startAt: { y: -150 }, opacity: 1, ease: Elastic.easeInOut }, '-=1')
                    .to(introText, 0.5, { x: 0, startAt: { x: -100 }, opacity: 1, ease: Power4.easeInOut }, '-=1')
                    .staggerTo(serviceFlows, 0.5, { opacity: 0.5, y: 0, startAt: { y: -100 }, ease: Back.easeIn }, 0.1, '-=1')
                    .add(createServiceFlowLineTween(serviceFlows, serviceFlowLines), '-=0.75')
                    .add(createServiceFlowCircleTween(serviceFlows, serviceFlowBoxes, serviceFlowCircles))
            }
            else {
                tweenServiceFlow = new TimelineMax()
                    .set(serviceFlowsContainer, { opacity: 1 })
                    .to(xLargeText, 1, { y: 0, startAt: { y: -150 }, opacity: 1, ease: Elastic.easeInOut })
                    .to(introText, 1, { y: 0, startAt: { y: +150 }, opacity: 1, ease: Elastic.easeInOut }, '-=1')
                    .to(introText, 0.5, { x: -100, opacity: 0, display: 'none', delay: 1, ease: Power1.easeInOut }, '-=1')
                    .staggerTo(serviceFlows, 1, { opacity: 0.5, y: 0, startAt: { y: -100 }, ease: Back.easeIn }, 0.15, '-=0.75')
                    .add(createServiceFlowLineTween(serviceFlows, serviceFlowLines), '-=0.5')
                    .add(createServiceFlowCircleTween(serviceFlows, serviceFlowBoxes, serviceFlowCircles), '-=0.5')
            }
        }

        function tweenOnComplete() {
            if (parseInt(ctrl.scrollableItem.contentIndex) === parseInt(ctrl.scrollableContents.totalSections)) {
                ctrl.scrollableContents.setArrowVisibility(false);
                ctrl.scrollableContents.setFooterVisibility(true);
            }
            else {
                ctrl.scrollableContents.setArrowVisibility(true);
            }
        }
        
        function createServiceFlowLineTween(serviceFlows, serviceFlowLines) {
            var serviceFlowLineTween = new TimelineMax();
            for (var indx = 0; indx < serviceFlowLines.length; indx++) {
                serviceFlowLineTween.from(serviceFlowLines[indx], 0.5, { opacity: 0, width: 0, ease: Power3.easeIn }, '-=0.5')
                    .to(serviceFlows[(indx + 1) == serviceFlowLines.length ? 0 : indx + 1], 0.15,
                        { autoAlpha: 0.4, yoyo: true, repeat: 1 })
            }
            serviceFlowLineTween.eventCallback('onComplete', tweenOnComplete);
            return serviceFlowLineTween;
        }

        function createServiceFlowCircleTween(serviceFlows, serviceFlowBoxes, serviceFlowCircles) {
            var serviceFlowCircleTween = new TimelineMax({ repeat: -1, repeatDelay: -0.25 });
            for (var indx = 0; indx < serviceFlowCircles.length; indx++) {
                serviceFlowCircleTween.to(serviceFlowCircles[indx], 0.5, { opacity: 1, ease: Power3.easeIn })
                    .to(serviceFlowCircles[indx], 1, { startAt: { x: -20 }, x: angular.element(serviceFlowBoxes[indx]).width(), opacity: 0, display: 'none', ease: Power3.easeIn }, '-=0.75')
                    .to(serviceFlows[(indx + 1) == serviceFlowCircles.length ? 0 : indx + 1], 0.25,
                        { autoAlpha: 1, yoyo: true, repeat: 1 })
            }
            return serviceFlowCircleTween;
        }

        scope.$on('animate', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenServiceFlow) {
                    tweenServiceFlow.time(0).restart();
                }
                else {
                    animate();
                }
            }
        })

        scope.$on('pauseAnimation', function (event, args) {
            if (args.index === parseInt(ctrl.scrollableItem.contentIndex)) {
                if (tweenServiceFlow) {
                    tweenServiceFlow.pause();
                }
            }
        })
    }
}